/**
 * @desc Yung-编辑字典信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(body: defs.basics.BaseDictionaryEditDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/dataDictionary/edit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
